import React from 'react'

export default function austraila() {
  return (
    <div>Australia</div>
  )
}
